import { render, staticRenderFns } from "./ProviderButtons.vue?vue&type=template&id=3545c186&scoped=true&"
import script from "./ProviderButtons.vue?vue&type=script&lang=js&"
export * from "./ProviderButtons.vue?vue&type=script&lang=js&"
import style0 from "./ProviderButtons.vue?vue&type=style&index=0&id=3545c186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545c186",
  null
  
)

export default component.exports